import { StepHorizontalSettings } from './types';

const commonTextSettings = {
  transform: 'translateX(-50%) translateY(8px)',
  left: '50%',
  top: '100%',
};

export const stepHorizontalSettings: StepHorizontalSettings = {
  componentVariants: {
    lineSize: {
      prop: 'lineSize',
      variants: {
        regular: {
          width: '100%',
          height: '2px',
        },
      },
    },
    color: {
      prop: 'color',
      variants: {
        disabled: {
          backgroundColor: 'gray.light',
          color: 'white.main',
        },
        active: {
          backgroundColor: 'success.main',
          color: 'white.main',
          boxShadow: '0px 0px 16px 4px rgba(59, 125, 91, 0.3)',
        },
        completed: {
          backgroundColor: 'success.light',
          color: 'white.main',
        },
      },
    },
    size: {
      prop: 'size',
      variants: {
        regular: {
          width: 28,
          height: 28,
          borderRadius: '50%',
          fontSize: 1,
          fontFamily: 'secondary',
          fontWeight: 2,
        },
      },
    },
    text: {
      prop: 'text',
      variants: {
        disabled: {
          ...commonTextSettings,
          color: 'gray.main',
        },
        active: {
          ...commonTextSettings,
          color: 'success.main',
        },
        completed: {
          ...commonTextSettings,
          color: 'success.light',
        },
      },
    },
  },
};
